import type { FunctionComponent } from 'react'
import React from 'react'
import { TooltipWithButton, TypographyV2 as Typography } from '@which/seatbelt'

import { pushToDatalayer } from '../utils'
import styles from './FilterTooltip.module.scss'

export const FilterTooltip: FunctionComponent<Props> = ({
  categorySlug,
  description,
  filterLabel,
  displayType = 'inline',
  title,
}) => {
  const tooltipJSX = (
    <TooltipWithButton
      data-testid="filter-tooltip"
      className={displayType === 'block' ? styles.blockTooltip : styles.inlineTooltip}
      title={title}
      ariaLabel={title || ''}
      contents={description || ''}
      openHandler={() => {
        pushToDatalayer({
          categorySlug,
          filter: title || '',
          segment: filterLabel,
        })
      }}
    />
  )

  return displayType === 'block' ? (
    <div className={styles.blockTooltipWrapper}>
      {tooltipJSX}
      <Typography tag="span" textStyle="sb-text-interface-body-small-regular">
        Info
      </Typography>
    </div>
  ) : (
    tooltipJSX
  )
}

///////IMPLEMENTATION/////////

type Props = {
  categorySlug: string
  description: string
  filterLabel: string
  displayType?: string
  title?: string
}
